<section class="container-fluid company-pops-shell">
  <div class="row">
    <div class="pb-2 mb-3 border-bottom col-12">
      <h2><b>Service delivery locations</b></h2>
      <p>Commercial PoPs with active services</p>
    </div>
  </div>

  <div *ngIf="isMckayUser" class="d-flex flex-wrap mb-3">
    <div class="col-12 p-fluid">
      <div class="col-nopad col-6 form-group row">
        <label class="col-4 col-form-label navbar-brand align-self-start"><b>Select company:</b></label>
        <div class="col-7 col-form-input">
          <p-dropdown [(ngModel)]="selectedCompanyId"
                      [filter]="true"
                      [options]="companyOptions"
                      [showClear]="true"
                      [disabled]="loadingCompanies"
                      placeholder="Choose an account"
                      (onChange)="onCompanyChange($event.value)">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-info" *ngIf="!selectedCompany">
    Select a company to display its service delivery locations.
  </div>

  <div *ngIf="selectedCompany">
    <app-service-delivery-locations-panel></app-service-delivery-locations-panel>
    <app-service-delivery-location-details></app-service-delivery-location-details>
  </div>
</section>
